export default __webpack_public_path__ + "static/media/743.eec21ddb.png";